import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
// core components
import styles from "assets/jss/components/headerStyle.js";
import LogoIcon from "components/icons/logoIcon";
import i18n from 'i18n';
import jss from 'jss';
import rtl from 'jss-rtl';

const useStyles = makeStyles(styles);

export default function Header(props) {
  const classes = useStyles();

  const { color, fixed, absolute, facilityName, logo } = props;
  const appBarClasses = classNames({
    [classes.appBar]: true,
    [classes[color]]: color,
    [classes.absolute]: absolute,
    [classes.fixed]: fixed
  });


  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  function changeLanguage(language) {
    i18n.changeLanguage(language);
    if (i18n.dir(language) === "rtl") {
      jss.use(rtl());
    }
    else {
      jss.use(rtl({ enabled: false }));
    }
    setOpen(false);
  };


  return (
    <AppBar className={appBarClasses}>
      <Toolbar className={classes.container}>
        <div className={classes.flex}>
          <div className={classes.title}><LogoIcon logo={logo} /></div>
          <div className={classes.facilityTitle}>
            <span >{facilityName}</span>
          </div>
        </div>
        {/* <Button
          ref={anchorRef}
          aria-controls={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          color="primary"
          variant="contained"
          className={classes.buttonLanguage}
        >
          Language
            </Button> 
        <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal className={classes.overAll}>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                    <MenuItem onClick={() => changeLanguage('en')}>English</MenuItem>
                    <MenuItem onClick={() => changeLanguage('es')}>Spanish</MenuItem>
                    <MenuItem onClick={() => changeLanguage('pl')}>Polish</MenuItem>
                    <MenuItem onClick={() => changeLanguage('hu')}>Hungarian</MenuItem>
                    <MenuItem onClick={() => changeLanguage('ar')}>Arabic</MenuItem>
                    <MenuItem onClick={() => changeLanguage('he')}>Hebrew</MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>*/}
      </Toolbar>
    </AppBar>
  );
}

Header.defaultProp = {
  color: "white"
};

Header.propTypes = {
  facilityName: PropTypes.string,
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "transparent",
    "white",
    "rose",
    "dark"
  ]),
  rightLinks: PropTypes.node,
  leftLinks: PropTypes.node,
  brand: PropTypes.string,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  // this will cause the sidebar to change the color from
  // props.color (see above) to changeColorOnScroll.color
  // when the window.pageYOffset is heigher or equal to
  // changeColorOnScroll.height and then when it is smaller than
  // changeColorOnScroll.height change it back to
  // props.color (see above)
  changeColorOnScroll: PropTypes.shape({
    height: PropTypes.number.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "info",
      "success",
      "warning",
      "danger",
      "transparent",
      "white",
      "rose",
      "dark"
    ]).isRequired,
    logo: PropTypes.string
  })
};
